import {Injectable} from '@angular/core';

interface NewRelicBrowserApi {
  addPageAction?: (name: string, attributes: Record<string, string | number>) => void;
  setCustomAttribute?: (name: string, value: string | number | null) => void;
  setUserId?: (userId: string | null) => void;
  setUserID?: (userId: string | null) => void;
}

@Injectable({providedIn: 'root'})
export class NewRelicBrowserService {
  private get api(): NewRelicBrowserApi | null {
    return (window['newrelic'] || window['NREUM']) as NewRelicBrowserApi || null;
  }

  setPlayerId(playerId: unknown): void {
    const numericPlayerId = this.positiveInteger(playerId);
    if (numericPlayerId === null) {
      return;
    }

    const api = this.api;
    if (api?.setUserId) {
      api.setUserId(String(numericPlayerId));
    } else {
      api?.setUserID?.(String(numericPlayerId));
    }
    api?.setCustomAttribute?.('player.id', numericPlayerId);
  }

  clearPlayerId(): void {
    const api = this.api;
    if (api?.setUserId) {
      api.setUserId(null);
    } else {
      api?.setUserID?.(null);
    }
    api?.setCustomAttribute?.('player.id', null);
  }

  addApiRequest(attributes: Record<string, string | number>): void {
    this.api?.addPageAction?.('ApiRequest', attributes);
  }

  positiveInteger(value: unknown): number | null {
    const numericValue = Number(value);
    return Number.isInteger(numericValue) && numericValue > 0 ? numericValue : null;
  }
}